import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import LandingPage from "@/pages/LandingPage";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import Invite from "@/pages/Invite";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { SignupProvider } from "@/components/SignupProvider";
import { AdminAuthProvider, useAdminAuth } from "@/context/AdminAuth";

function ProtectedAdmin({ children }) {
  const { user, checking } = useAdminAuth();
  if (checking || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FBFBF9]">
        <Loader2 className="h-6 w-6 animate-spin text-[#2F5E43]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function PublicSite() {
  return (
    <SignupProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/invite/:token" element={<Invite />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </SignupProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedAdmin>
                  <AdminDashboard />
                </ProtectedAdmin>
              }
            />
            <Route path="/*" element={<PublicSite />} />
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
